import {useState} from 'react';
import {useForm} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import {PostCareService} from '../../../../backend/requests/post-care-service';
import {translations} from '../../../../i18n/translations';
import {FetchEntityUsersResult} from '../../../../hooks/use-fetch-entity-users';
import {useModalBtns} from '../../../modal/use-modal-btns';
import {createPostCareService} from '../data/care-service-data-transformation';
import {CareServiceCreatingItem, CareServiceForm} from '../data/care-service-item';
import {CareServicesBaseModal} from './care-services-base-modal';

export type CareServicesCreateModalProps = {
  open: boolean;
  item: CareServiceCreatingItem;
  caregivers: FetchEntityUsersResult;
  seniors: FetchEntityUsersResult;
  onCancel: () => void;
  onConfirm: (item: PostCareService) => Promise<void>;
};

export function CareServicesCreateModal(props: CareServicesCreateModalProps) {
  const {t} = useTranslation();
  const [loading, setLoading] = useState(false);

  const formInstance = useForm<CareServiceForm>({
    mode: 'onChange',
    defaultValues: {
      title: props.item.title,
      color: props.item.color,
      startDate: props.item.startDate,
      endDate: props.item.endDate,
      twentyFourHours: props.item.twentyFourHours,
      repetition: props.item.repetition,
      targetUserId: props.item.targetUserId,
      responsibleUserIds: props.item.responsibleUserIds,
      notes: undefined,
    },
  });

  const actionBtns = useModalBtns({
    left: {
      type: 'cancel',
      disabled: loading,
      onClick: props.onCancel,
    },
    right: {
      type: 'add',
      disabled: !formInstance.formState.isValid,
      onClick: async () => {
        try {
          setLoading(true);
          const formValues = formInstance.getValues();
          const newItem = createPostCareService(formValues);
          await props.onConfirm(newItem);
        } finally {
          setLoading(false);
        }
      },
      loading: loading,
    },
  });

  return (
    <CareServicesBaseModal
      open={props.open}
      title={t(translations.care_services.modals.create.title)}
      actions={actionBtns}
      form={formInstance}
      caregivers={props.caregivers}
      seniors={props.seniors}
    />
  );
}
